export default __webpack_public_path__ + "static/media/No.7-3.4f66356b.jpg";